import clsx from 'clsx';
import { recipeStatusToDescription } from '../../../modules/MachineUtils';
import { IconButton } from '@material-ui/core';
import leftDoubleArrowIcon from '../../../res/images/left_double_arrow.svg';
import leftArrowIcon from '../../../res/images/left_arrow.svg';
import rightArrowIcon from '../../../res/images/right_arrow.svg';
import Button from '../../../components/Button';
import rightDoubleArrowCircleIcon from '../../../res/images/right_double_arrow_circle.svg';
import rightDoubleArrowIcon from '../../../res/images/right_double_arrow.svg';
import React, { useEffect, useRef, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { hexColorToCSSFilter } from '../../../modules/CSSUtils';
import {
    formatTemperature,
    temperatureIsUnavailable,
} from './MachineParameters';
import { DateTime } from 'luxon';
import { usePrevious } from '../../../modules/HookUtils';
import Authentication from '../../../modules/Authentication';
import LoadingOverlay from '../../../components/LoadingOverlay';

const CELL_WIDTH = '94';
const COLUMN_MOVEMENT_COUNT = 4; // How many column should we move left/right when pressing the left/right buttons
const CAPSULES_REFRESH_RATE = 60000; // How frequently should we get new logs

const gApiClient = Authentication.getAPIClient();

const useStyles = makeStyles({
    content: {
        display: 'flex',
        flexDirection: 'column',
        height: 0,
        flexGrow: 1,
        width: '100%',
        overflowY: 'none',
    },
    headerContainer: {
        marginBottom: '4px',
        boxShadow: '2px 0px 5px 1px rgba(0,0,0,0.34)',
        backgroundColor: '#d1d8e1',
        display: 'flex',
    },
    dataContainer: {
        overflowX: 'auto',
    },
    capsuleContainer: {
        display: 'flex',
    },
    cell: {
        flex: 1,
        border: '1px solid #ccc',
        padding: '8px',
    },
    narrow: {
        flex: 0.25,
    },
    wide: {
        flex: 2,
    },
    center: {
        textAlign: 'center',
    },
});

function downloadCapsulesConsumptions(
    machineId,
    startTime,
    endTime,
    onNewCapsules
) {
    const params =
        startTime && endTime
            ? `start_date=${startTime.toFormat(
                  'yyyy-MM-dd'
              )}&end_date=${endTime.toFormat('yyyy-MM-dd')}`
            : null;
    gApiClient
        .callApi(
            `admin/getMachineConsumptions/${machineId}?${params ? params : ''}`,
            'GET',
            {},
            {}
        )
        .then((response) => {
            const capsules = response.data;
            onNewCapsules(capsules);
        });
}

/** Parameters table view */
export default function ParametersCapsules(props) {
    const classes = useStyles();
    const [capsules, setCapsules] = useState(null);

    let checkForLogsTimer = null;

    const refreshLatestCapsules = () => {
        const today = DateTime.local();

        downloadCapsulesConsumptions(
            props.machineId,
            today,
            today,
            (newCapsules) => {
                console.log('New capsules', newCapsules.length);

                checkForLogsTimer = setTimeout(
                    refreshLatestCapsules,
                    CAPSULES_REFRESH_RATE
                );

                setCapsules(newCapsules);
            }
        );
    };

    useEffect(() => {
        // Periodically get new capsules
        checkForLogsTimer = setTimeout(
            refreshLatestCapsules,
            capsules === null ? 0 : CAPSULES_REFRESH_RATE
        );

        return () => {
            clearTimeout(checkForLogsTimer);
        };
    }, [capsules, props.machineId]);

    if (capsules === null) {
        return <LoadingOverlay loading={true} />;
    }

    return (
        <div className={classes.content}>
            <div className={clsx(classes.headerContainer)}>
                <div
                    className={clsx(
                        classes.cell,
                        classes.narrow,
                        classes.center
                    )}
                >
                    #
                </div>
                <div className={classes.cell}>Time</div>
                <div className={clsx(classes.cell, classes.wide)}>Recipe</div>
                <div className={classes.cell}>ID</div>
                <div className={clsx(classes.cell, classes.center)}>
                    Delay (Sec)
                </div>
                <div className={clsx(classes.cell, classes.center)}>
                    Prep Time (Sec)
                </div>
                <div className={clsx(classes.cell, classes.center)}>
                    Total Time (Sec)
                </div>
                <div className={clsx(classes.cell, classes.center)}>
                    Max Motor Current
                </div>
            </div>
            <div className={classes.dataContainer}>
                {capsules.map((c, i) => (
                    <div className={classes.capsuleContainer} key={i}>
                        <div
                            className={clsx(
                                classes.cell,
                                classes.narrow,
                                classes.center
                            )}
                        >
                            {i + 1}
                        </div>
                        <div className={clsx(classes.cell)}>
                            {DateTime.fromMillis(c.consumption_date).toFormat(
                                'HH:mm'
                            )}
                        </div>
                        <div className={clsx(classes.cell, classes.wide)}>
                            {c.recipe_type_description}
                        </div>
                        <div className={clsx(classes.cell)}>{c.capsule_id}</div>
                        <div className={clsx(classes.cell, classes.center)}>
                            {c.delay_time ? c.delay_time / 1000 : 'N/A'}
                        </div>
                        <div className={clsx(classes.cell, classes.center)}>
                            {c.prep_time ? c.prep_time / 1000 : 'N/A'}
                        </div>
                        <div className={clsx(classes.cell, classes.center)}>
                            {c.total_time ? c.total_time / 1000 : 'N/A'}
                        </div>
                        <div className={clsx(classes.cell, classes.center)}>
                            {c.max_motor_current ? c.max_motor_current : 'N/A'}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
